import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
  Linking,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { MenuItem, MenuProps } from './types';
import { menuStyled as styled } from './styled';
import UserMenu from './components/UserMenu';
import { Footer } from '../../components/Footer';
import MenuCollapse from './components/MenuCollapse';
import { TextInput } from '../../components/TextInput/TextInput';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../../components/Image';
import { Button } from '../../components/Button';
import { menuItems } from './constants';
import { wooCommerceApi } from '../../services/api/wooCommerceApi';
import { useDispatch } from 'react-redux';
import { setEShopCategories } from '../../services/redux/reducers/EShopCategorySlice';
import { COLORS, FONTS } from '../../constants';
import { upperCase } from 'lodash';
import ECardMember from '../../components/ECardMember/ECardMember';

const Menu: FC<MenuProps> = ({ navigation }) => {
  const dispatch = useDispatch();
  const [openECard, setOpenECard] = useState(false);

  const getCategories = useCallback(async () => {
    try {
      const res = await wooCommerceApi.get('products/categories', {
        per_page: 20,
        parent: 0,
      });
      dispatch(setEShopCategories(res.data));
    } catch (error: any) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    getCategories();
  });

  return (
    <ScrollView>
      <View style={styled.container}>
        <UserMenu />
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          marginBottom: 7,
        }}
      >
        <TouchableOpacity
          onPress={() => {
            setOpenECard(true);
          }}
          style={{
            paddingHorizontal: 10,
            paddingVertical: 6,
            backgroundColor: COLORS.GREEN,
            borderRadius: 6,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Image
            style={{
              width: 30,
              height: 30,
              marginRight: 7,
            }}
            source={require('../../assets/ecard.png')}
          />
          <Text
            style={{
              color: COLORS.WHITE,
              fontSize: 16,
              fontFamily: FONTS.IowanOldStyleBTRoman,
              textAlign: 'center',
              textTransform: 'uppercase',
            }}
          >
            E-member Card
          </Text>
        </TouchableOpacity>
      </View>
      <View style={styled.container}>
        {menuItems.map((item) => (
          <MenuCollapse menuItem={item} key={item.title} />
        ))}
      </View>
      <View style={[styled.container, { marginVertical: 30 }]}>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Image
            source={require('../../assets/search_white.png')}
            style={{
              width: 22,
              height: 22,
              resizeMode: 'contain',
              marginTop: 10,
              tintColor: STYLE_VARS.primaryColor,
            }}
          />
          <TextInput
            placeholder="SEARCH"
            placeholderTextColor={STYLE_VARS.textColor}
            pointerEvents="box-none"
            style={{
              color: STYLE_VARS.textColor,
              fontSize: 18,
              borderBottomColor: STYLE_VARS.textColor,
              paddingBottom: 4,
              borderBottomWidth: 0.5,
              borderColor: STYLE_VARS.textColor,
              textAlign: 'center',
              flex: 1,
            }}
          />
        </View>
        <View style={{ paddingVertical: 20 }}>
          <Button
            text="VISIT PUBLIC WEBSITE"
            style={STYLE_VARS.blueButton}
            onPress={() => {
              const url = 'https://kcc.org.hk/';
              Linking.openURL(url);
            }}
          />
        </View>
      </View>
      <Footer />
      <ECardMember openModal={openECard} setOpenModal={setOpenECard} />
    </ScrollView>
  );
};
export default Menu;
